
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import IconPromoGift from '~/assets/icons/partner/icon-promo-gift.svg?inline'
import PartnerPromoAction from '~/components/partners/PartnerPromoAction.vue'

@Component({
  components: {
    PartnerPromoAction,
    IconPromoGift,
  },
})
export default class PartnerPromo extends Vue {
  @Prop({ type: String, required: true })
  readonly partnerName!: string

  @Prop({ type: String, required: true })
  readonly promocode!: string

  @Prop({ type: String, required: true })
  readonly text!: string
}
